import EventEmitter from 'owa-event-emitter';
import { A2HSMetric, logMetric } from './a2hsMetrics';
import { BeforeInstallPromptEvent } from '../schema/BeforeInstallPromptEvent';

export enum A2HSEvent {
    BEFORE_INSTALL_PROMPT = 'beforeinstallprompt',
    APP_INSTALLED = 'appinstalled',
}

export const a2hsEventEmitter = new EventEmitter();

export const registerA2HSEventListeners = (source?: string) => {
    registerA2HSEventListener(A2HSEvent.BEFORE_INSTALL_PROMPT, (ev: BeforeInstallPromptEvent) => {
        beforeInstallPromptEventListener(ev, source);
    });
    registerA2HSEventListener(A2HSEvent.APP_INSTALLED, appInstalledEventListener);
};

const registerA2HSEventListener = (ev: A2HSEvent, listener: EventListenerOrEventListenerObject) => {
    window.addEventListener(ev, listener);
};

export let beforeInstallPromptEvent: BeforeInstallPromptEvent = null;
const beforeInstallPromptEventListener = (ev: BeforeInstallPromptEvent, source: string) => {
    ev.preventDefault?.();
    logMetric(A2HSMetric.USER_ELIGIBLE, { source });

    /**
     * NOTE: Sometimes, the 'beforeInstallPrompt' event fires even before our React code gets chance to run.
     * So, storing the event in an exportable variable to later retrieve from React code when it runs.
     */
    beforeInstallPromptEvent = ev;

    a2hsEventEmitter.emit(A2HSEvent.BEFORE_INSTALL_PROMPT, ev);
};

const appInstalledEventListener = () => {
    logMetric(A2HSMetric.INSTALLED);
    a2hsEventEmitter.emit(A2HSEvent.APP_INSTALLED);
};
